"use client"

import dynamic from "next/dynamic"

/**
 * The waitlist modal for the focused-quiz chrome.
 *
 * `PageShell` mounts `<WaitlistModal />` for every normal page, but the
 * `(quiz-chrome)` layout deliberately renders no navbar/footer, so it never
 * got one. `WaitlistProvider` sits above both route groups in
 * `[locale]/layout.tsx`, which made the failure silent rather than loud:
 * `openWaitlist()` set `isOpen` on a provider whose modal wasn't rendered
 * anywhere, so the result page's coming-soon CTA appeared to do nothing.
 *
 * Lazy + client-only, mirroring how PageShell loads it, so the funnel's
 * initial chunk doesn't grow for visitors who never hit a coming-soon tier.
 */
const WaitlistModal = dynamic(
  () =>
    import("@/components/ui/waitlist").then((m) => ({
      default: m.WaitlistModal,
    })),
  { ssr: false, loading: () => null }
)

export function QuizChromeWaitlistModal() {
  return <WaitlistModal />
}
